import React from "react";
import "../Css/Njs.css";

// import { PyFooter } from "./PyFooter";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { Navbar } from "../Components/Nav";
import { NFooter } from "./NFooter";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const NModule = () => {
  const [loading, setLoading] = useState(false);
  let [color, setColor] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <div className="App">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "210px",
            }}
          >
            <DotLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={100}
            />
          </div>
        ) : (
          <>
            <div class="container-fluid background_node">
              <div className="row">
                <Navbar />
                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div>
                    <img
                      className="logo"
                      src={process.env.PUBLIC_URL + "assets/images/njslogo.png"}
                      width="85%"
                      alt="pylogo"
                      height="auto"
                    />
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>

            <div
              class="container-fluid"
              style={{
                backgroundColor: "black",
                paddingTop: "60px",
              }}
            >
              <div className="row mt-2">
                <h1 className="py_h1">Node.js Modules</h1>

                <div>
                  <p>
                    In Node.js, Modules are the blocks of encapsulated code that
                    communicates with an external application on the basis of
                    their related functionality. Modules can be a single file or
                    a collection of multiples files/folders. The reason
                    programmers are heavily reliant on modules is because of
                    their re-usability as well as the ability to break down a
                    complex piece of code into manageable chunks.
                  </p>
                </div>
              </div>

              <hr style={{ color: "white" }} />
              <div className=" row mt-4">
                <h1 className="py_h1">Modules are of three types:</h1>
                <div className="col-md-4 mt-5" style={{ color: "white" }}>
                  <ul>
                    <li style={{ color: "white" }}>Core Modules</li>
                  </ul>
                  <p>
                    Core Modules: Node.js has many built-in modules that are
                    part of the platform and comes with Node.js installation.
                    These modules can be loaded into the program by using the
                    require function.
                    <br />
                    <br />
                    The require() function will return a JavaScript type
                    depending on what the particular module returns. The
                    following example demonstrates how to use the Node.js Http
                    module to create a web server.
                  </p>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example </h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     var http = require('http');
                     http.createServer(function (req, res) {
                       res.writeHead(200, {'Content-Type': 'text/html'});
                       res.write('Welcome to this page!');
                       res.end();
                     }).listen(3000);
                       `}
                    </code>
                  </pre>
                  <br />
                  <br />
                  <p>
                    In the above example, the require() function returns an
                    object because the Http module returns its functionality as
                    an object. The function http.createServer() method will be
                    executed when someone tries to access the computer on port
                    3000. The res.writeHead() method is the status code where
                    200 means it is OK, while the second argument is an object
                    containing the response headers.
                    <br />
                    <br />
                    Since this file provides attributes to the outer world via
                    exports, another file can use its exported functionality
                    using the require() function.
                  </p>
                </div>
                <div className="col-md-4 mt-5" style={{ color: "white" }}>
                  <ul>
                    <li>local Modules</li>
                  </ul>
                  <p>
                    Local Modules: Unlike built-in and external modules, local
                    modules are created locally in your Node.js application.
                    Let’s create a simple calculating module that calculates
                    various operations. Create a calc.js file that has the
                    following code:
                  </p>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example </h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     var calculator = require('./calc'); 
    
                     var x = 50, y = 10; 
                         
                     console.log("Addition of 50 and 10 is "
                                        + calculator.add(x, y)); 
                         
                     console.log("Subtraction of 50 and 10 is "
                                        + calculator.sub(x, y)); 
                         
                     console.log("Multiplication of 50 and 10 is "
                                        + calculator.mult(x, y)); 
                         
                     console.log("Division of 50 and 10 is " 
                                        + calculator.div(x, y));
                       `}
                    </code>
                  </pre>
                  <p>
                    Since this file provides attributes to the outer world via
                    exports, another file can use its exported functionality
                    using the require() function.
                  </p>
                </div>
                <div className="col-md-4 mt-5">
                  <ul>
                    <li style={{ color: "white" }}>Third-party Modules</li>
                  </ul>
                  <p>
                    Third-party modules: Third-party modules are modules that
                    are available online using the Node Package Manager(NPM).
                    These modules can be installed in the project folder or
                    globally. Some of the popular third-party modules are
                    mongoose, express, angular, and react.
                    <br />
                    <br />
                    <div
                      // className="bg-info"
                      style={{
                        textAlign: "center",
                        backgroundColor: "#5d7b89",
                        fontFamily: "Fira Mono",

                        fontWeight: "bolder",
                      }}
                    >
                      <h3>Example </h3>
                    </div>
                    <pre>
                      <code>
                        {`
                            
                            npm install express
                            npm install mongoose
                             npm install -g @angular/cli
                          `}
                      </code>
                    </pre>
                  </p>
                </div>
                <div className="bg-primary">
                  <p>
                    Note-: Step to run this program: Run index.js file using the
                    following command:
                    <br />
                    node index.js
                  </p>
                </div>
              </div>
            </div>
            <NFooter />
          </>
        )}
      </div>
    </>
  );
};
